import { globalState } from './globalState'
import { IRanchWebShopCallProperties, ITrackPayload } from './types'
import { getTokenAndLanguage, msToSec } from './utils'

export const trackOpenAction = (sid: string): void => {
    const config = globalState.getConfig()
    const store = globalState.getStore()
    const now = Date.now()
    const parameters = getTokenAndLanguage(store)
    const { zoneId } = parameters
    const sessionId = sid
    const { playerId, gameId, networkId, instanceId, sourceId } = store
    trackAction({
        eventId: config.WEB_SHOP_CALL_TRACK_ID,
        date: msToSec(now),
        unixtimeMS: now,
        sessionId,
        zoneId: zoneId ? Number.parseInt(zoneId, 10) : undefined,
        playerId: Number.parseInt(playerId as string, 10),
        gameId: Number.parseInt(gameId, 10),
        networkId: Number.parseInt(networkId, 10),
        instanceId: Number.parseInt(instanceId, 10),
        sourceId,
    } as IRanchWebShopCallProperties)
}

export const trackAction = (payload: ITrackPayload): void => {
    const config = globalState.getConfig()
    const cxf = globalState.getCxf()
    cxf.emit(config.CXF_TRACK_MSG, payload)
}
